(() => {
  const initialize = (container) => {
    if (container.dataset.personalizedReady) return;
    container.dataset.personalizedReady = 'true';

    const form = container.closest('form');
    const photo = container.querySelector('[data-personalized-photo]');
    const description = container.querySelector('[data-personalized-description]');
    let previewUrl;

    if (photo) {
      const preview = container.querySelector('[data-personalized-preview]');
      const image = container.querySelector('[data-personalized-preview-image]');
      const fileName = container.querySelector('[data-personalized-file-name]');
      const emptyFile = container.querySelector('[data-personalized-empty-file]');
      photo.addEventListener('change', () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        const file = photo.files[0];
        preview.hidden = !file;
        if (emptyFile) emptyFile.hidden = !!file;
        if (!file) return;
        previewUrl = URL.createObjectURL(file);
        image.src = previewUrl;
        fileName.textContent = file.name;
      });
    }

    container.querySelectorAll('[data-character-input]').forEach((input) => {
      const count = input.closest('.personalized-order__field').querySelector('[data-character-count]');
      const update = () => { count.textContent = `${input.value.length} / ${input.maxLength}`; };
      input.addEventListener('input', update);
      update();
    });

    const validate = () => {
      if (description) description.setCustomValidity('');
      if (photo) photo.setCustomValidity('');
      if (container.dataset.requireOne === 'true' && (photo || description)) {
        const hasPhoto = photo && photo.files.length > 0;
        const hasDescription = description && description.value.trim().length > 0;
        if (!hasPhoto && !hasDescription) {
          const target = description || photo;
          target.setCustomValidity(container.dataset.oneOfMessage);
        }
      }
      return form.reportValidity();
    };

    if (photo) photo.addEventListener('change', () => photo.setCustomValidity(''));
    if (description) description.addEventListener('input', () => description.setCustomValidity(''));

    form.addEventListener('click', (event) => {
      if (!event.target.closest('xo-cart-add')) return;
      if (validate()) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    form.addEventListener('submit', (event) => {
      if (validate()) return;
      event.preventDefault();
    });
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-personalized-order]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
